











import { Product, ProductStatus } from '@/api';
import { ProductOrdwayAttributes } from '@/models/ordway';
import { OrdwayService } from '@/services/ordway-service';
import { Component, Vue, Prop } from 'vue-property-decorator';
import TooltipButton from '../elements/buttons/tooltip-button.vue';
import { getGeneralActionText } from '@/common/HelpTextUtils';

@Component({
	components: { TooltipButton },
	methods: {
		getGeneralActionText,
	},
	computed: {
		ProductStatus() {
			return ProductStatus;
		},
	},
})
export default class BillingSetupButton extends Vue {
	@Prop(Object)
	private product!: Product | null;

	@Prop(Object)
	private productOrdwayAttribute!: ProductOrdwayAttributes | null;

	public onNewOrdwayPlan: boolean = false;

	public async created(): Promise<void> {
		this.onNewOrdwayPlan = await OrdwayService.isOnNewOrdwayPlan(
			this.product,
			this.productOrdwayAttribute,
		);
		this.onNewOrdwayPlan = true;
	}

	public openEditBillingModal(): void {
		this.$bvModal.show('edit-billing-modal');
	}
}
